import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiPost, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';

export function useDisconnectQuickBooks() {
  const queryClient = useQueryClient();
  return useApiMutation<void, void>({
    mutationFn: () => apiPost<void>(operationsClient, settingsEndpoints.qbDisconnect()),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: settingsKeys.quickbooks() });
      toast.success('QuickBooks disconnected');
    },
  });
}
